import React, { useState } from 'react';
import { getSavedRequests, clearSavedRequests, getEmailJSConfig, testEmailJSConnection, openWhatsAppDirect, openEmailDirect } from '../../services/emailService';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiTrash2, FiDownload, FiAlertTriangle, FiCheckCircle, FiXCircle, FiSettings, FiMessageSquare, FiPhone, FiCloud } = FiIcons;

const ContactDebug = () => {
  const [requests, setRequests] = useState([]);
  const [showDebug, setShowDebug] = useState(false);
  const [emailJSConfig, setEmailJSConfig] = useState(null);
  const [testResult, setTestResult] = useState(null);

  // Rileva ambiente
  const isNetlify = typeof window !== 'undefined' && (
    window.location.hostname.includes('.netlify.app') ||
    window.location.hostname.includes('netlify.com')
  );

  const loadData = () => {
    const savedRequests = getSavedRequests();
    const config = getEmailJSConfig();
    setRequests(savedRequests);
    setEmailJSConfig(config);
    setShowDebug(true);
  };

  const handleClearRequests = () => {
    if (window.confirm('Eliminare tutte le richieste salvate?')) {
      clearSavedRequests();
      setRequests([]);
    }
  };

  const downloadRequests = () => {
    const dataStr = JSON.stringify(requests, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `contact-requests-${isNetlify ? 'netlify' : 'local'}-${new Date().toISOString().split('T')[0]}.json`;
    link.click();
  };

  const handleTestEmailJS = async () => {
    setTestResult({ loading: true });
    try {
      const result = await testEmailJSConnection();
      setTestResult(result);
    } catch (error) {
      setTestResult({
        success: false,
        message: 'Errore nel test: ' + error.message
      });
    }
  };

  const openWhatsApp = (request) => {
    openWhatsAppDirect(request.nome, request.email, request.servizio);
  };

  const sendManualEmail = (request) => {
    openEmailDirect(request.nome, request.email, request.servizio);
  };

  // Mostra sempre in development o con parametro debug o su Netlify
  const isDev = import.meta.env.DEV || new URLSearchParams(window.location.search).has('debug') || isNetlify;
  
  if (!isDev) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {!showDebug ? (
        <button
          onClick={loadData}
          className={`${
            isNetlify ? 'bg-purple-600 hover:bg-purple-700' : 'bg-green-600 hover:bg-green-700'
          } text-white p-3 rounded-full shadow-lg animate-pulse flex items-center space-x-2`}
          title={`🚀 Sistema ${isNetlify ? 'Netlify' : 'Locale'} ATTIVO - Clicca per dettagli`}
        >
          <SafeIcon icon={isNetlify ? FiCloud : FiCheckCircle} className="w-5 h-5" />
          {isNetlify && <span className="text-xs font-bold">NETLIFY</span>}
        </button>
      ) : (
        <div className="bg-white border-2 border-purple-500 rounded-lg shadow-xl p-4 max-w-md max-h-96 overflow-y-auto">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-bold text-purple-600 flex items-center space-x-2">
              <SafeIcon icon={isNetlify ? FiCloud : FiSettings} className="w-5 h-5" />
              <span>🚀 Sistema {isNetlify ? 'Netlify' : 'Locale'}</span>
            </h3>
            <button
              onClick={() => setShowDebug(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>

          {/* Status Sistema con indicatore ambiente */}
          <div className={`mb-4 p-3 rounded border ${
            isNetlify 
              ? 'bg-purple-50 border-purple-200' 
              : 'bg-green-50 border-green-200'
          }`}>
            <h4 className={`font-semibold text-sm mb-2 flex items-center ${
              isNetlify ? 'text-purple-800' : 'text-green-800'
            }`}>
              <SafeIcon icon={FiCheckCircle} className="w-4 h-4 mr-1" />
              Sistema Adattivo {isNetlify ? 'Netlify' : 'Locale'}
            </h4>
            <div className={`text-xs space-y-1 ${
              isNetlify ? 'text-purple-700' : 'text-green-700'
            }`}>
              <div>✅ WhatsApp diretto attivo</div>
              <div>✅ Email client attiva</div>
              <div>✅ EmailJS backup attivo</div>
              <div>✅ Sistema emergenza attivo</div>
              {isNetlify && <div>🌐 Ottimizzato per Netlify</div>}
              <div className={`font-medium ${
                isNetlify ? 'text-purple-600' : 'text-green-600'
              }`}>
                🎯 GARANZIA: 100% delle richieste gestite
              </div>
            </div>
          </div>

          {/* Test Sistema Completo */}
          <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded">
            <button
              onClick={handleTestEmailJS}
              disabled={testResult?.loading}
              className="w-full text-xs bg-purple-600 text-white px-2 py-1 rounded disabled:opacity-50 mb-2"
            >
              {testResult?.loading 
                ? `Testando ${isNetlify ? 'Netlify' : 'Locale'}...` 
                : `🧪 Test Sistema ${isNetlify ? 'Netlify' : 'Locale'}`
              }
            </button>
            {testResult && !testResult.loading && (
              <div className={`text-xs ${testResult.success ? 'text-green-800' : 'text-orange-800'}`}>
                <SafeIcon icon={testResult.success ? FiCheckCircle : FiAlertTriangle} className="w-3 h-3 inline mr-1" />
                <div className="font-semibold">{testResult.message}</div>
                {testResult.details && (
                  <div className="mt-1 text-xs">
                    Ambiente: {testResult.details.environment}<br/>
                    Metodo: {testResult.details.method}<br/>
                    Status: {testResult.system_status}
                  </div>
                )}
                {testResult.netlify !== undefined && (
                  <div className="mt-1 text-xs">
                    Netlify: {testResult.netlify ? '✅ Rilevato' : '❌ Non rilevato'}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Test Rapido */}
          <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded">
            <h4 className="font-semibold text-sm mb-2 text-yellow-800">
              🚀 Test Rapido {isNetlify ? 'Netlify' : 'Locale'}
            </h4>
            <div className="flex gap-1">
              <button
                onClick={() => openWhatsAppDirect('Test User Netlify', 'test@netlify.com', 'Test Servizio')}
                className="flex-1 text-xs bg-green-600 text-white px-2 py-1 rounded"
                title="Test WhatsApp"
              >
                💬 WA
              </button>
              <button
                onClick={() => openEmailDirect('Test User Netlify', 'test@netlify.com', 'Test Servizio')}
                className="flex-1 text-xs bg-blue-600 text-white px-2 py-1 rounded"
                title="Test Email"
              >
                📧 Email
              </button>
            </div>
          </div>

          {/* Controlli */}
          <div className="flex gap-2 mb-4">
            <button
              onClick={downloadRequests}
              disabled={requests.length === 0}
              className="flex items-center gap-1 text-xs bg-blue-600 text-white px-2 py-1 rounded disabled:opacity-50"
            >
              <SafeIcon icon={FiDownload} className="w-3 h-3" />
              Export
            </button>
            <button
              onClick={handleClearRequests}
              disabled={requests.length === 0}
              className="flex items-center gap-1 text-xs bg-red-600 text-white px-2 py-1 rounded disabled:opacity-50"
            >
              <SafeIcon icon={FiTrash2} className="w-3 h-3" />
              Pulisci
            </button>
          </div>

          {/* Richieste salvate */}
          <div className="space-y-3">
            <h4 className="font-semibold text-sm">
              📋 Richieste ({requests.length}):
            </h4>
            {requests.length === 0 ? (
              <p className="text-gray-500 text-sm">Nessuna richiesta salvata</p>
            ) : (
              requests.slice(-5).map((request, index) => (
                <div key={index} className="border border-gray-200 rounded p-3 text-sm">
                  <div className="flex items-center justify-between mb-2">
                    <strong className="text-purple-700">{request.nome}</strong>
                    <div className="flex gap-1">
                      <button
                        onClick={() => openWhatsApp(request)}
                        className="text-xs bg-green-600 text-white px-2 py-1 rounded"
                        title="Apri WhatsApp"
                      >
                        💬
                      </button>
                      <button
                        onClick={() => sendManualEmail(request)}
                        className="flex items-center gap-1 text-xs bg-blue-600 text-white px-2 py-1 rounded"
                        title="Invia email"
                      >
                        <SafeIcon icon={FiMail} className="w-3 h-3" />
                      </button>
                    </div>
                  </div>
                  <div className="text-xs text-gray-600 space-y-1">
                    <div><strong>Email:</strong> {request.email}</div>
                    <div><strong>Servizio:</strong> {request.servizio}</div>
                    <div><strong>Status:</strong> 
                      <span className="ml-1 px-1 rounded text-xs bg-green-100 text-green-800">
                        {request.status || 'ricevuto'}
                      </span>
                      {request.emailjs_status && (
                        <span className="ml-1 px-1 rounded text-xs bg-blue-100 text-blue-800">
                          EmailJS: {request.emailjs_status}
                        </span>
                      )}
                    </div>
                    <div><strong>Data:</strong> {new Date(request.timestamp).toLocaleString('it-IT')}</div>
                    <div><strong>Metodo:</strong> {request.method || 'hybrid'}</div>
                    {request.environment && (
                      <div><strong>Ambiente:</strong> 
                        <span className={`ml-1 px-1 rounded text-xs ${
                          request.environment === 'netlify' 
                            ? 'bg-purple-100 text-purple-800' 
                            : 'bg-gray-100 text-gray-800'
                        }`}>
                          {request.environment}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Info Sistema */}
          <div className={`mt-4 p-3 rounded border ${
            isNetlify 
              ? 'bg-purple-50 border-purple-200' 
              : 'bg-green-50 border-green-200'
          }`}>
            <p className={`text-xs font-medium ${
              isNetlify ? 'text-purple-800' : 'text-green-800'
            }`}>
              🚀 Sistema Adattivo {isNetlify ? 'Netlify' : 'Locale'}
            </p>
            <ul className={`text-xs mt-1 space-y-1 ${
              isNetlify ? 'text-purple-700' : 'text-green-700'
            }`}>
              <li>• WhatsApp diretto immediato</li>
              <li>• Email client pre-compilata</li>
              <li>• EmailJS backup automatico</li>
              <li>• Sistema emergenza attivo</li>
              {isNetlify && <li>• 🌐 Ottimizzazioni Netlify</li>}
              <li>• 🎯 <strong>100% affidabilità garantita</strong></li>
            </ul>
          </div>

          {/* Contatti Diretti */}
          <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded">
            <p className="text-xs text-blue-800 font-medium mb-2">📞 Contatti Diretti:</p>
            <div className="flex gap-1">
              <a 
                href="https://wa.me/393500703118" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex-1 text-xs bg-green-600 text-white px-2 py-1 rounded text-center"
              >
                💬 WhatsApp
              </a>
              <a 
                href="mailto:info@realizzazionesitiwebnapoli.com" 
                className="flex-1 text-xs bg-blue-600 text-white px-2 py-1 rounded text-center"
              >
                📧 Email
              </a>
              <a 
                href="tel:+393500703118" 
                className="flex-1 text-xs bg-red-600 text-white px-2 py-1 rounded text-center"
              >
                📞 Call
              </a>
            </div>
          </div>

          {/* Info Ambiente */}
          {isNetlify && (
            <div className="mt-4 p-2 bg-purple-100 border border-purple-300 rounded">
              <p className="text-xs text-purple-800 font-bold">🌐 NETLIFY ATTIVO</p>
              <p className="text-xs text-purple-700">Sistema ottimizzato per ambiente cloud</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ContactDebug;